import { Button } from '@heroui/react';
import { useAuth } from '../hooks/auth-provider';

export default function ImpersonationBanner() {
  const { stopImpersonating } = useAuth();

  return (
    <div className='sticky top-0 z-50 bg-yellow-500 text-black px-4 py-2 flex items-center justify-between'>
      <div className='flex items-center gap-2'>
        <span className='font-semibold'>Impersonation Mode Active</span>
        <span className='text-sm'>You are viewing (and acting!) as another user.</span>
      </div>
      <Button size='sm' color='default' variant='flat' onPress={stopImpersonating}>
        Stop Impersonating
      </Button>
    </div>
  );
}
